import { render, staticRenderFns } from "./Responsable.vue?vue&type=template&id=6e4d068b&"
import script from "./Responsable.vue?vue&type=script&lang=js&"
export * from "./Responsable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports